import React, { useContext, useState, useEffect, useRef } from 'react';
import Logo from './logoHeader';
import { GrSearch } from "react-icons/gr";
import { FaRegCircleUser } from "react-icons/fa6";
import { FaShoppingCart } from "react-icons/fa";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { setUserDetails } from '../store/userSlice';
import ROLE from '../common/role';
import Context from '../context';
import { MdHome } from "react-icons/md";
import { MdPayment } from "react-icons/md";  // Payment Icon
import { PiSignOut } from "react-icons/pi";
import { IoPersonCircle } from "react-icons/io5";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import ElmotkadmaLogo from './ElmotkadmaLogo';


const Header = () => {
  const user = useSelector(state => state?.user?.user);
  const dispatch = useDispatch();
  const context = useContext(Context);
  const navigate = useNavigate();
  const searchInput = useLocation();
  const URLSearch = new URLSearchParams(searchInput?.search);
  const searchQuery = URLSearch.getAll("q");
  const [search, setSearch] = useState(searchQuery);
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    const fetchData = await fetch(SummaryApi.logout_user.url, {
      method: SummaryApi.logout_user.method,
      credentials: 'include',
    });

    const data = await fetchData.json();

    if (data.success) {
      toast.success(data.message);
      dispatch(setUserDetails(null));
      navigate("/");
    }

    if (data.error) {
      toast.error(data.message);
    }
    setIsMenuOpen(false);
  };

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearch(value);
    if(user?.role===ROLE.ADMIN){
      if(user?.type==="Cosmetic"){
        if (value) {
          navigate(`/admin-search-cosmetic-product?q=${value}`);
        } else {
          navigate("/admin-search-cosmetic-product");
        }

      }
      else if (user?.type==="Medicine"){
        if (value) {
          navigate(`/admin-search-product?q=${value}`);
        } else {
          navigate("/admin-search-product");
        }
      }
      else if(user?.type==="Admin"){
        if (value) {
          navigate(`/admin-boss-search-product?q=${value}`);
        } else {
          navigate("/admin-boss-search-product");
        }
      }
      
    }
    else{
      if (value) {
        navigate(`/search?q=${value}`);
      } else {
        navigate("/search");
      }
    }
    
  };

  const handleProfileClick = () => {
    setIsMenuOpen(!isMenuOpen);  
  };

  const handlePersonalInformation = () => {
    if (user?.role === ROLE.ADMIN) {
      navigate('/AdminPanelPersonalInfo/adminProfile');
    }
    if(user?.role === ROLE.SALESMAN){
      navigate("/SalesManPanelPersonalInfo/salesManProfile");
    }
    
    else if (user?.role === ROLE.GENERAL) {
      navigate('/userProfile');
    }

    setIsMenuOpen(false); 
  };

  const handleSiteInformation = () => {
    if (user?.role === ROLE.ADMIN) {
      if(user?.type === "Admin"){
        navigate('/admin-panel/all-users');
      }
      else{
        navigate('/admin-panel/all-products');
      }
      
    }
    if(user?.role === ROLE.SALESMAN){
      navigate("/salesManPanel/salesManViewOrders");
    }
    
    else if (user?.role === ROLE.GENERAL) {
      navigate('/order-history');
    }

    setIsMenuOpen(false); 
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <header className='h-16 shadow-md bg-white fixed w-full z-40'>
      <div className='h-full container mx-auto flex items-center px-4 justify-between'>
        {/* Logo */}
        <div className="flex items-center space-x-2 md:space-x-4"> {/* Decrease space for mobile */}
  <Link to={"/"}>
    {/* Smaller size for mobile, larger for desktop */}
    <Logo className="w-10 h-10 md:w-16 md:h-16" w={40} h={40} />
  </Link>

  {/* 
<div className="border-l-2 h-8 md:h-11 border-gray-300"></div> 

<Link to={"/"}>
  <ElmotkadmaLogo className="w-10 h-10 md:w-16 md:h-16" w={40} h={40} />
</Link>
*/}
</div>


        
        {/* Home Link */}
        
        
        <div className='flex gap-1 lg:gap-4'>


        {/* Conditional Button */}
        
        {user?._id &&user?.type!=='Admin'&& (
            <div className='flex items-center justify-center rounded text-white bg-yellow-600 hover:bg-yellow-500 px-2 py-2 '>
              <Link to={user.role === ROLE.ADMIN ? '/admin-panel/admin-all-requests' : user.role === ROLE.SALESMAN ? '/salesmanPaymentRequest' : '/userPaymentRequest'} className='flex items-center space-x-0 lg:space-x-2'>
                <MdPayment size={20} className='mx-auto' />
                <span className='hidden lg:inline ml-1'>{user.role === ROLE.ADMIN ? 'المديونية' : 'سداد المديونية'}</span>
              </Link>
            </div>
          )}

        </div>

        {/* Search Bar */}
{ (
  <div className='relative flex items-center w-full justify-between max-w-[160px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-sm border rounded focus-within:shadow h-[30px] sm:h-[34px] p-1 sm:p-2'>

    <input
      type='text'
      placeholder='... ابحث عن المنتجات'
      className='w-full outline-none p-1 text-sm lg:text-base text-right pr-[40px]' // Add padding to the right for the icon
      onChange={handleSearch}
      value={search}
    />

    <div className='absolute right-0 top-0 h-full w-[40px] bg-blue-900 flex items-center justify-center rounded-r text-white'>
      <GrSearch />
    </div>

  </div>
)}


        {/* Right Side Icons and Links */}
        <div className='flex items-center gap-3 sm:gap-7'>

{user?.type !== 'Admin' && (
  <div className='items-center justify-center rounded-full px-2 py-2 hidden md:block'> {/* Hide on small screens, show on md and up */}
    <Link to={"/"} className='flex items-center space-x-0 lg:space-x-2'>
      <MdHome size={30} className='mx-auto text-blue-900' />
    </Link>
  </div>
)}


           {/* Cart Icon */}
          
                    {user?._id && (user?.role===ROLE.GENERAL || user?.role===ROLE.SALESMAN) &&(
            <Link to={"/cart"} className='text-xl sm:text-2xl relative'>
              <span><FaShoppingCart className='mx-auto text-blue-900'/></span>
              <div className='bg-blue-700 text-white w-4 h-4 sm:w-5 sm:h-5 rounded-full p-1 flex items-center justify-center absolute -top-2 -right-3'>
                <p className='text-sm sm:text-sm'>{context?.cartProductCount}</p>
              </div>
            </Link>
          )}
          {/* User Profile Icon */}
          {user?._id && (
            <div ref={dropdownRef} className='text-2xl cursor-pointer relative flex justify-center' onClick={handleProfileClick}>
              {user?.profilePic ? (
                <img src={user?.profilePic} className='w-8 h-8 sm:w-10 sm:h-10 rounded-full' alt={user?.name} />
              ) : (
                <FaRegCircleUser  className='w-8 h-8 sm:w-10 sm:h-10'/>
                
              )}
            <IoIosArrowDropdownCircle 
              className='text-xl text-blue-900 absolute -bottom-2 -right-1' 
            />
              
               {/* Dropdown Menu */}
               {isMenuOpen && (
                <div className="absolute top-full right-0 mt-2 bg-blue-50 shadow-lg rounded-lg py-2 text-right z-50 w-60 md:w-52 ">
                  <button
                    onClick={handlePersonalInformation}
                    className=" w-full px-4 py-3 text-sm md:text-base text-blue-900 font-medium hover:bg-blue-100 hover:text-blue-700 transition-colors duration-300 flex justify-between items-center"
                  >
                    
                    <IoPersonCircle className="text-xl" />
                    <span>المعلومات الشخصية</span>
                  </button>
                  
                  <button
                    onClick={handleSiteInformation}
                    className=" w-full px-4 py-3 text-sm md:text-base text-blue-900 font-medium hover:bg-blue-100 hover:text-blue-700 transition-colors duration-300 flex justify-between items-center"
                  >
                    
                    <HiMiniWrenchScrewdriver className="text-xl" />
                   { user?._id && user?.role===ROLE.GENERAL &&<span>ادارة شئون الحساب</span>} 
                   { user?._id && user?.role===ROLE.SALESMAN &&<span>ادارة مبيعات الموقع</span>} 
                   { user?._id && user?.role===ROLE.ADMIN && user?.type!=='Admin'&&<span>ادارة شئون المخزن</span>} 
                   { user?._id && user?.role===ROLE.ADMIN  && user?.type==='Admin'&&<span>ادارة شئون الموقع</span>} 
                   
                    
                  </button>

                  <button
                    onClick={handleLogout}
                    className=" w-full px-4 py-3 text-sm md:text-base text-red-600 font-medium hover:bg-red-100 hover:text-red-700 transition-colors duration-300 flex justify-between items-center"
                  >
                    <PiSignOut className="text-xl" />
                    <span>تسجيل الخروج</span>
                    
                  </button>
                </div>
              )}

            </div>
          )}



          {/* Login Button */}
          
          <div>
          {!user?._id && (
              <Link to={"/login"} className='px-2 py-1 text-xs xs:text-[10px] sm:text-base rounded text-white bg-blue-900 hover:bg-blue-800'>تسجيل الدخول</Link>
            )}
          </div>
          
        </div>
      </div>
    </header>
  );
};

export default Header;
